import { t } from '@gem/modules/i18n';

import Tasks from 'APP/Tasks';
import Entities from 'STORE';

interface IHandleInvalidQuoteParams {
  groupId: string;
  userText?: string;
}

export function handleInvalidQuote({ groupId, userText }: IHandleInvalidQuoteParams): void {
  Tasks.app.showToast(t('chat_quote_text_modified_message'));

  const inputPanel = Entities.InputPanelsStore.getById(groupId);

  if (inputPanel && userText) {
    inputPanel.setValue(userText);
  }

  Tasks.messaging.endQuote(groupId);
}
